import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      // Main
      path: "/",
      component: () => import("@/views/main.vue")
    },
    {
      // Main
      path: "/main",
      component: () => import("@/views/main.vue")
    },
    {
      // 商户资料
      path: "/merchants-information",
      component: () => import("@/views/information/merchantsInformation.vue")
    },
    {
      // 商户资料修改
      path: "/merchants-information/edit",
      component: () => import("@/views/information/merchantsInformationEdit.vue")
    },
    {
      // 联系资料
      path: "/contact-information",
      component: () => import("@/views/information/contactInformation.vue")
    },
    {
      // 商户资料修改详情
      path: "/merchants-information/edit-detail",
      component: () => import("@/views/information/merchantsInformationEditDetail.vue")
    },
    {
      // 商户修改失败钱包
      path: "/merchants-wallet/edit",
      component: () => import("@/views/information/merchantsWalletEdit.vue")
    },
    // {
    //   // 商家资料修改
    //   path: "/main/edit",
    //   component: () => import("@/views/main-edit.vue")
    // },
    {
      // Main-mobile
      path: "/main-mobile",
      name: "main-mobile",
      component: () => import("@/views/main-mobile.vue")
    },
    {
      // 移动版的商家资料修改
      path: "/main-mobile/edit",
      name: "main-mobile-edit",
      component: () => import("@/views/main-mobile-edit.vue")
    },

    /*********************************************************/

    {
      // 登录
      path: "/login",
      name: "login",
      component: () => import("@/views/login.vue")
    },
    {
      // 忘记密码
      path: "/forgetPassword",
      name: "forgetPassword",
      component: () => import("@/views/forgetPassword.vue")
    },

    /*********************************************************/

    {
      // 注册 - 账号
      path: "/reg",
      name: "reg",
      component: () => import("@/views/reg/reg.vue"),
      children: [
        {
          // 注册 - 账号
          path: "1",
          name: "reg-1",
          component: () => import("@/views/reg/reg-1.vue")
        },
        {
          // 注册 - 输入用户信息
          path: "2",
          name: "reg-2",
          component: () => import("@/views/reg/reg-2.vue")
        },
        {
          // 注册 - 绑定手机和邮箱
          path: "3",
          name: "reg-3",
          component: () => import("@/views/reg/reg-3.vue")
        },
        {
          // 注册 - 完成
          path: "done",
          name: "reg-done",
          component: () => import("@/views/reg/reg-done.vue")
        }
      ]
    },

    {
      // 注册 - Mobile - 账号
      path: "/reg-mobile",
      name: "reg-mobile",
      component: () => import("@/views/reg/reg.vue"),
      children: [
        {
          // 注册 - 账号
          path: "1",
          name: "reg-1-mobile",
          component: () => import("@/views/reg/reg-1-mobile.vue")
        },
        {
          // 注册 - 输入用户信息
          path: "2",
          name: "reg-2-mobile",
          component: () => import("@/views/reg/reg-2-mobile.vue")
        },
        {
          // 注册 - 绑定手机和邮箱
          path: "3",
          name: "reg-3-mobile",
          component: () => import("@/views/reg/reg-3-mobile.vue")
        },
        {
          // 注册 - 完成
          path: "done",
          component: () => import("@/views/reg/reg-done.vue")
        }
      ]
    },

    /*********************************************************/

    {
      // 收款账户列表
      path: "/payment",
      name: "payment",
      component: () => import("@/views/payment/paymentList.vue")
    },
    {
      // 商家充值审批
      path: "/rechargeAudit",
      name: "rechargeAudit",
      component: () => import("@/views/recharge/rechargeAudit.vue")
    },
    {
      // 交易流水
      path: "/transactionLog",
      name: "transactionLog",
      component: () => import("@/views/transaction/transactionLog.vue")
    },
    {
      // 收款账户 - 钱包详情
      path: "/payment/:account_id/:settle_account",
      name: "payment-detail",
      component: () => import("@/views/payment/payment.vue")
    },
    {
      // 收款账户 - 银行卡详情
      path: "/payment/:account_id",
      name: "payment-detail-card",
      component: () => import("@/views/payment/payment.vue")
    },
    {
      // 钱包验证
      path: "/payment/:account_id/verify",
      component: () => import("@/views/payment/walletVerify.vue")
    },
    {
      // 钱包详情
      path: "/payment/:account_id/detail",
      component: () => import("@/views/payment/walletDetail")
    },

    {
      // 收款账户列表 - 移动版
      path: "/payment-mobile",
      name: "payment-mobile",
      component: () => import("@/views/payment/paymentList-mobile.vue")
    },
    {
      // 收款账户 - 详情 - 移动版
      path: "/payment-mobile/:account_id",
      name: "payment-detail-mobile",
      component: () => import("@/views/payment/payment-mobile.vue")
    },

    /*********************************************************/

    {
      // 营销账户列表
      path: "/outlay",
      name: "outlay",
      component: () => import("@/views/outlay/outlayList.vue")
    },
    {
      // 营销账户 - 详情入口
      path: "/outlay/:outlay_account_id",
      component: () => import("@/views/outlay/outlay.vue"),
      children: [
        {
          // 营销账户 - 详情
          path: "",
          name: "outlay-detail",
          component: () => import("@/views/outlay/outlayDetail.vue")
        },
        {
          // 营销账户 - 积分详情
          path: "coin",
          name: "outlay-coin",
          component: () => import("@/views/outlay/outlayCoin.vue")
        },
        {
          // 营销账户 - 现金券详情
          path: "coupon",
          name: "outlay-coupon",
          component: () => import("@/views/outlay/outlayCoupon.vue")
        },
        {
          // 营销账户 - 现金券详情 - 券包详情
          path: "coupon/:package_id",
          name: "outlay-coupon-detail",
          component: () => import("@/views/outlay/outlayCouponDetail.vue")
        },
        {
          // 营销账户 - 余额动态
          path: "activity",
          name: "outlay-activity",
          component: () => import("@/views/outlay/outlayActivity.vue")
        },
        {
          // 营销账户 - 充值
          path: "recharge",
          name: "outlay-recharge",
          component: () => import("@/views/outlay/outlayRecharge.vue")
        },
        {
          // 营销账户 - 充值确认
          path: "rechargeApply",
          name: "outlay-recharge-apply",
          component: () => import("@/views/outlay/outlayRechargeApply.vue")
        },
        {
          // 营销账户 - 余额转换 / 套餐购买
          path: "package",
          name: "outlay-package",
          component: () => import("@/views/outlay/outlayPackage.vue")
        }
      ]
    },

    /*********************************************************/

    {
      // 结算账户列表
      path: "/settle/",
      name: "settle",
      component: () => import("@/views/settle/settleList.vue")
    },
    {
      // 结算账户 - 详情入口
      path: "/settle/:settle_type/:settle_account_id",
      component: () => import("@/views/settle/settle.vue")
      // children: [
      //   { // 结算账户 - 详情
      //     path:   '',
      //     name:   'settle-detail',
      //     component:  () => import('@/views/settle/settleDetail.vue'),
      //   },
      // ],
    },

    /*********************************************************/

    {
      // 富力钱包注册-1
      path: "/wallet/reg-wallet-1/:settle_account/:settle_id",
      component: () => import("@/views/wallet/reg-wallet-1.vue")
    },
    {
      // 富力钱包注册-2
      path: "/wallet/reg-wallet-2/:settle_account/:settle_id",
      component: () => import("@/views/wallet/reg-wallet-2.vue")
    },
    {
      // 富力钱包注册-3
      path: "/wallet/reg-wallet-3/:settle_account/:settle_id",
      component: () => import("@/views/wallet/reg-wallet-3.vue")
    },
    {
      // 富力钱包注册-4
      path: "/wallet/reg-wallet-4/:settle_account/:settle_id",
      component: () => import("@/views/wallet/reg-wallet-4.vue")
    },

    {
      // 富力钱包修改安全手机
      path: "/wallet/reg-wallet-5/:settle_account/:settle_id",
      component: () => import("@/views/wallet/reg-wallet-5.vue")
    },

    {
      // 富力钱包重绑安全手机
      path: "/wallet/reg-wallet-6/:settle_account/:settle_id",
      component: () => import("@/views/wallet/reg-wallet-6.vue")
    },

    {
      // 富力钱包详情
      path: "/wallet/detail/:settle_account/:settle_id",
      component: () => import("@/views/wallet/detail.vue")
    },

    {
      // 富力钱包详情
      path: "/wallet/withdraw/:settle_account/:settle_id",
      component: () => import("@/views/wallet/withdraw.vue")
    },

    /*********************************************************/

    {
      // 交易流水
      path: "/pay-record",
      name: "pay-record",
      component: () => import("@/views/pay-record.vue")
    },

    /*********************************************************/

    {
      // 角色列表
      path: "/roleList",
      name: "roleList",
      component: () => import("@/views/roleList.vue")
    },
    {
      // 子账号列表
      path: "/childAccountList",
      name: "childAccountList",
      component: () => import("@/views/childAccountList.vue")
    },

    /*********************************************************/

    {
      // 修改密码
      path: "/editPassword",
      name: "editPassword",
      component: () => import("@/views/editPassword.vue")
    },
    {
      // 修改密码 - 移动版
      path: "/editPassword-mobile",
      name: "editPassword-mobile",
      component: () => import("@/views/editPassword-mobile.vue")
    },

    {
      // 消息通知
      path: "/sysMsg",
      name: "sysMsg",
      component: () => import("@/views/sysMsg.vue")
    },

    /*********************************************************/

    {
      // 超级提现页面
      path: "/withdraw/:ticket/:settle_id/:amount",
      name:"withdraw",
      component: () => import("@/views/withdraw.vue")
    },

    /*********************************************************/
    {
      // 浏览器兼容
      path: "/browser",
      name:"browser",
      component: () => import("@/views/browser.vue")
    }
  ]
});
